<template>
  <v-tooltip
    v-model="showTooltip"
    :color="tooltipColor"
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
  >
    <template #activator="{ on, attrs }">
      <v-card
        v-touch="$ftTap(() => setTooltip(!showTooltip))"
        width="min-content"
        style="border: 2px solid black;"
        :class="{'my-1': $vuetify.breakpoint.smAndDown}"
        class="px-2 font-weight-bold"
        :ripple="false"
      >
        <div class="py-1 text-no-wrap text-truncate">
          {{ tableNames }}
        </div>
      </v-card>
    </template>
    <span class="font-weight-bold">{{ tableNames }}</span>
  </v-tooltip>
</template>

<script>
import touchHelpers from '@/ft-vue-core/mixins/touchHelpers'
export default {
  name: 'TableNamesCard',
  mixins: [touchHelpers],
  props: {
    tableNames: String,
    tooltipColor: String,
    top: Boolean,
    bottom: Boolean,
    left: Boolean,
    right: Boolean,
    disableTooltip: Boolean,
  },
  data () {
    return {showTooltip: false}
  },
  methods: {
    setTooltip (value) {
      this.$set(this, 'showTooltip', value)
      return value
    }
  }
}
</script>

<style scoped>
.v-card::before {
  background: none;
}
</style>